import axios from 'axios';

export const NP_API_URL = '/api/v1/delivery-addresses/nova-post';
export const NP_SEARCH_DEBOUNCE_MS = 300;

export function extractCitySearchQuery(city) {
  if (!city) return '';
  let query = city.trim();
  if (query.toLowerCase().startsWith('м. ')) {
    query = query.slice(3).trim();
  }
  const commaIdx = query.indexOf(',');
  if (commaIdx > 0) {
    query = query.slice(0, commaIdx).trim();
  }
  const parenIdx = query.indexOf('(');
  if (parenIdx > 0) {
    query = query.slice(0, parenIdx).trim();
  }
  return query;
}

export function buildCitySearchQueries(cityName) {
  if (!cityName) return [];
  const trimmed = cityName.trim();
  const extracted = extractCitySearchQuery(trimmed);
  if (!extracted) return [trimmed];
  if (extracted.toLowerCase() === trimmed.toLowerCase()) return [trimmed];
  return [trimmed, extracted];
}

function findDeliveryCityRef(addresses, cityName, settlementRef) {
  if (!addresses?.length) return '';

  const normalizedCityName = cityName?.trim().toLowerCase() || '';
  const searchName = extractCitySearchQuery(cityName).toLowerCase();

  let deliveryCityMatch = '';
  let exactNameMatch = '';
  let partialNameMatch = '';

  for (const address of addresses) {
    if (settlementRef && address.Ref === settlementRef && address.DeliveryCity) {
      return address.DeliveryCity;
    }
    if (settlementRef && address.DeliveryCity === settlementRef && address.DeliveryCity) {
      deliveryCityMatch = address.DeliveryCity;
    }
    const present = address.Present?.trim().toLowerCase() || '';
    if (normalizedCityName && present === normalizedCityName && address.DeliveryCity) {
      exactNameMatch = address.DeliveryCity;
    } else if (searchName && present.includes(searchName) && address.DeliveryCity) {
      if (!partialNameMatch) partialNameMatch = address.DeliveryCity;
    }
  }

  return deliveryCityMatch || exactNameMatch || partialNameMatch || '';
}

async function searchSettlements(cityName) {
  const response = await axios.post(NP_API_URL, {
    modelName: 'AddressGeneral',
    calledMethod: 'searchSettlements',
    methodProperties: {
      CityName: cityName,
      Limit: '50',
      Page: '1',
    },
  });

  if (!response.data?.success) {
    return [];
  }

  return response.data.data?.[0]?.Addresses || [];
}

/**
 * Повертає DeliveryCity (CityRef для getWarehouses/getStreet) за назвою міста та Ref населеного пункту.
 * У БД зберігається лише novaPostCityRef (Ref з searchSettlements), а не DeliveryCity.
 */
export async function resolveNovaPostDeliveryCityRef(cityName, settlementRef) {
  if (!cityName && !settlementRef) {
    return '';
  }

  try {
    for (const searchQuery of buildCitySearchQueries(cityName)) {
      const addresses = await searchSettlements(searchQuery);
      const deliveryCityRef = findDeliveryCityRef(addresses, cityName, settlementRef);
      if (deliveryCityRef) {
        return deliveryCityRef;
      }
    }
    return '';
  } catch (error) {
    console.error('Error resolving Nova Poshta delivery city ref:', error);
    return '';
  }
}
